<template>
  <v-container>
    <v-tabs v-model="tab" centered>
      <v-tab>{{ $t('menuHeaders.employerGuarantees')}}</v-tab>
      <v-tab>{{ $t('menuHeaders.contractorGuarantees')}}</v-tab>
    </v-tabs>
    <v-row class="ma-1">
      <v-spacer />
      <v-btn
        rounded
        dense
        small
        color="primary"
        @click="handleCreateOrEdit()"
        :disabled="!canUserEdit"
      >
        <v-icon> mdi-plus </v-icon>
        {{ $t('guarantees.add') }}
      </v-btn>
    </v-row>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <GuaranteesTable
          :contract="contract"
          site="employer"
          :items="employerGuarantees"
          @FETCH_DATA="handleFetchData"
          @EDIT_VARIATION="handleCreateOrEdit"
        />
      </v-tab-item>
      <v-tab-item>
        <GuaranteesTable
          :contract="contract"
          site="contractor"
          :items="contractorGuarantees"
          @FETCH_DATA="handleFetchData"
          @EDIT_VARIATION="handleCreateOrEdit"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { getGuarantees } from '@/services'
import { DEFAULT_GUARANTEE, SITES } from '@/helpers'
import { mapState } from 'vuex'

export default {
  name: 'GuaranteesView',
  props: {
    contract: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      tab: 0,
      items: []
    }
  },
  mounted () {
    if (this.contract && this.contract.id) {
      this.handleFetchData(this.contract.id)
    }
  },
  computed: {
    ...mapState({
      canUserEdit: state => state.userPermissionsToContract.canUserEdit
    }),
    employerGuarantees () {
      return this.items.filter(i => i.site === SITES.employer)
    },
    contractorGuarantees () {
      return this.items.filter(i => i.site === SITES.contractor)
    }
  },
  methods: {
    async handleFetchData () {
      this.items = await getGuarantees(this.contract.id)
    },
    handleCreateOrEdit (guarantee = DEFAULT_GUARANTEE) {
      guarantee.contractId = guarantee.contractId || this.contract.id
      this.$eventBus.$emit('OPEN_MODAL', {
        component: 'GuaranteeForm',
        options: { maxWidth: 1050 },
        scope: {
          value: guarantee,
          contract: this.contract,
          site: !this.tab ? SITES.employer : SITES.contractor
        },
        handlers: {
          update: async (item) => {
            await this.handleFetchData()
          }
        }
      })
    }
  },
  watch: {
    contract () {
      this.handleFetchData()
    }
  }
}
</script>
